import type { ConnectionResponse } from '~/features/onboarding/types/connection.types';

/**
 * Connector codes that identify a Meta Commerce destination. Runs carry the
 * backend's short code (`META`), connections carry the connector type
 * (`META_COMMERCE`); both mean the same destination.
 */
const META_CONNECTOR_CODES = new Set(['META', 'META_COMMERCE']);

/** `true` when a run's / job's connector code is a Meta Commerce destination. */
export function isMetaConnectorCode(code: string | null | undefined): boolean {
  return code != null && META_CONNECTOR_CODES.has(code.toUpperCase());
}

/** `true` when a connection is a Meta Commerce connection (the only type the delivery workspace serves). */
export function isMetaConnection(connection: ConnectionResponse | undefined): boolean {
  return connection?.type === 'META_COMMERCE';
}
